import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ApiDataDemo } from '../../../data';
import { useTemplate } from '../../features/template/TemplateProvider';
import { handleAllControllersRoutes } from './ApiPageOperation';

const ApiPageContext = createContext();
export const useApiPage = () => useContext(ApiPageContext);

function ApiPageProvider({ children }) {
    const [allControllerData, setAllControllerData] = useState(ApiDataDemo);
    const [reloadKey, setReloadKey] = useState(0);
    const [params, setParams] = useState({});
    const { setMessage } = useTemplate();

    useEffect(() => {
        setAllControllerData(ApiDataDemo);
        if (Object?.keys(params).length > 0) {
            handleAllControllersRoutes(params)
                .then(({ data }) => {
                    setAllControllerData(data);
                })
                .catch((err) => {
                    setMessage({ type: 'error', text: err.toString(0) });
                    setAllControllerData({});
                });
        }
    }, [params, reloadKey, setMessage]);

    const value = useMemo(() => {
        const handleReload = () => {
            setReloadKey((cuData) => cuData + 1);
        };

        return {
            allControllerData,
            setAllControllerData,
            reloadKey,
            setReloadKey,
            handleReload,
            params,
            setParams
        };
    }, [allControllerData, params, reloadKey]);

    return <ApiPageContext.Provider value={value}>{children}</ApiPageContext.Provider>;
}

export default ApiPageProvider;
